<template>
  <header class="header" v-if="routeLayout.isHeader">
    <div class="inner">
      <div class="left" v-if="routeLayout.isBack">
        <button class="h-btn back" @click="fnBack"></button>
        <!--                <div class="text">헤더내용</div>-->
      </div>
      <div class="left" v-if="routeLayout.isMenu">
        <button class="h-btn menu" onclick="document.querySelector('nav').classList.add('on');"></button>
        <!--        <button class="h-btn menu" @click="fnShowMenu"></button>-->
      </div>
      <h1 class="logo" v-if="routeLayout.isLogo" @click="fnPage('/main')"></h1>
      <div class="text">{{ routeLayout.titleName }}</div>
    </div>
  </header>
</template>

<script setup>
import { modalNames } from '@/components/common/globalComponent';
const { MENU } = modalNames;
import { computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import store from '@/store';
import router from '@/router';

const route = useRoute();
const path = computed(() => route.path);

const { getters, dispatch } = useStore();
const { proxy } = getCurrentInstance();

const routeLayout = computed(() => {
  return getters['layout/getRouteLayout'];
});

const fnShowMenu = () => {
  store.commit('layout/setIsMenu', { isMenu: true });
};

const fnPage = path => router.push({ path: path });

const showModalComponent = componentName => {
  dispatch('layout/pushModalComponent', {
    component: componentName,
    callback: () => {}
  });
};

const fnBack = () => {
    router.go(-1); // 정상적으로 뒤로 가기
};

// export default {
//   name: 'the-header',
//   setup() {
//     const { proxy } = getCurrentInstance();
//     const fnBack = () => {
//       proxy.$router.go(-1);
//     };
//     return {
//       ...layoutState(),
//       fnBack
//     };
//   }
// };
</script>

<style scoped></style>
